import styled from 'styled-components';

const SkuStyled = styled.div`
  position: relative;
  margin: 16px 0;
`;

const SkuGroup = styled.ul`
  display: flex;
  flex-wrap: wrap;

  > li {
    margin: 8px;
    margin-left: 0;

    > label {
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      text-align: center;
      color: #666;
      background: #fff;
      border: 1px solid #999;
      box-sizing: border-box;
      border-radius: 16px;
      padding: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      cursor: pointer;
      margin: 1px;
    }

    > input[type='radio'] {
      display: none;

      &:checked {
        + label {
          margin: 0px;
          border: 2px solid #333;
          color: #333;
          font-weight: bold;
        }
      }
    }

    &:last-child {
      margin-right: 0;
    }
  }
`;

export default SkuStyled;
export { SkuStyled, SkuGroup };
